import React, { useState } from "react";
import ReactModal from "react-modal";
import "./assign-bank-modal.scss";
import Select from "react-select";
import { Button } from "react-bootstrap";
import { useEffect } from "react";
import {
    ListOfPdfs,
    getActiveBanks,
    overrideBankDetails,
    getPreappById,
} from "../../../api";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const AssignBankModal = ({ show, onClose, sendForSignature = false, hideThisModal }) => {
    const [activeBanks, setActiveBanks] = useState([]);
    const [listOfPdfs, setListOfPdfs] = useState([]);
    const [isGuarantor, setIsGuarantor] = useState(true);
    const [selectedTypeOfBanks, setSelectedTypeOfBanks] = useState([]);
    const [activeTypeOfBank, setActiveTypeOfBank] = useState(null);
    const [savedBank, setSavedBank] = useState([]);
    const [savedAddendums, setSavedAddendums] = useState([]);
    const [seletedPdf, setSeletedPdf] = useState([]);
    const [bank_file_mapping, setBank_file_mapping] = useState([]);
    const [active_addendum_list, setActive_addendum_list] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        getActiveBanks().then((res) => {
            if (res.data) {
                const options = res.data.length
                    ? res.data.map((i) => ({ value: i.name, label: i.name }))
                    : [];
                setActiveBanks([...options]);
            }
        });
        ListOfPdfs().then((res) => {
            if (res.data.addendums_names) {
                let tempAddendumsArray = [];
                res.data.addendums_names.map((file_name, key) => {
                    tempAddendumsArray.push({
                        value: file_name,
                        label: file_name,
                    });
                });
                setListOfPdfs(tempAddendumsArray);
                setBank_file_mapping(res.data.bank_file_mapping);
            }
        });
        getPreappById({ id: show })
            .then((response) => {
                if (response.status) {
                    setSavedBank(response.data.override_bank || []);
                    setSavedAddendums(response.data.override_addendums || []);
                    setSelectedTypeOfBanks(response.data.override_bank || []);
                    setActiveTypeOfBank(
                        response.data.override_bank?.[0] || null,
                    );
                    setSeletedPdf(response.data.override_addendums || []);
                }
            })
            .catch((error) => {
                console.log("error", error);
            });
    }, []);

    const removeError = (keys) => {
        setError((prevErrors) => {
            if (!prevErrors) return null;
            
            const keysToRemove = Array.isArray(keys) ? keys : [keys];
            const newErrors = { ...prevErrors };
            
            keysToRemove.forEach((key) => {
                delete newErrors[key];
            });
    
            return Object.keys(newErrors).length > 0 ? newErrors : null;
        });
    };

    const onChangeTypeofBanks = (values, context) => {
        const latest_bank = values[values?.length - 1] || null;
        setSelectedTypeOfBanks(values);
        setSavedBank(values);
        if (context.action === "remove-value") {
            onRemoveBank(context.removedValue);
        }
        setActiveTypeOfBank(latest_bank || null);
        removeError(['bank']);
    };

    const onSelecttypeOfBank = (typeOfBank) => {
        setActiveTypeOfBank(typeOfBank);
    };
    const onChangePdf = (e, item) => {
        const itemName = item;

        setSeletedPdf((prevSelectedFdf) => {
            if (savedAddendums.includes(itemName)) {
                const updatedSavedAddendums = savedAddendums.filter(
                    (name) => name !== itemName,
                );
                setSavedAddendums(updatedSavedAddendums);
                return prevSelectedFdf.filter((name) => name !== itemName);
            } else {
                const updatedSelectedPdf = [...prevSelectedFdf];
                const index = updatedSelectedPdf.indexOf(itemName);
                if (index === -1) {
                    updatedSelectedPdf.push(itemName);
                } else {
                    updatedSelectedPdf.splice(index, 1);
                }
                return updatedSelectedPdf;
            }
        });
    };
    const onSubmit = () => {
        const data = {
            app_id: show,
            bank: selectedTypeOfBanks.length ? selectedTypeOfBanks : [],
            addendum: seletedPdf,
            sendForSignature: sendForSignature,
            isGuarantor: isGuarantor,
        };
        overrideBankDetails(data).then((res) => {
            onClose();
            if (res?.pending_approval || res?.requires_approval) {
                MySwal.fire({
                    title: <p>Overrides saved successfully! {res?.pending_approval ? 'Awaiting Manager Approval.' : 'Sent to manager for approval.'}</p>,
                    icon: "success",
                    toast: true,
                    position: "top-end",
                    timer: 0,
                    timerProgressBar: false,
                    showConfirmButton: true,
                    customClass: "margin-top-sweetalert",
                });
            } else {
                MySwal.fire({
                    title: <p>Overrides saved successfully! Application sent for signature.</p>,
                    icon: "success",
                    toast: true,
                    position: "top-end",
                    timer: 4000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    customClass: "margin-top-sweetalert",
                });
            }
        }).catch((error) => {
            if (error?.status === 422) {
                setError(error?.data?.errors);
            }
        });    
    };

    useEffect(() => {
        if (activeTypeOfBank !== null && bank_file_mapping.length !== 0) {
            let bank = activeTypeOfBank.value;
            let active_addendums = bank_file_mapping[bank];
            if (
                active_addendums !== undefined &&
                active_addendums?.addendums !== undefined
            ) {
                setActive_addendum_list(active_addendums.addendums);
            } else {
                setActive_addendum_list([]);
            }
        } else {
            setActive_addendum_list([]);
        }
    }, [activeTypeOfBank]);

    const onRemoveBank = (removedVal) => {
        let bank = removedVal.value;
        let removed_bank_addendums = bank_file_mapping[bank]?.addendums;
        if (removed_bank_addendums !== undefined) {
            let new_pdfs_array = [];
            seletedPdf.forEach((pdf) => {
                if (!removed_bank_addendums.includes(pdf)) {
                    new_pdfs_array.push(pdf);
                }
            });
            setSeletedPdf(new_pdfs_array);
        }
    };

    return (
        <ReactModal isOpen={Boolean(show)} className="assign-bank-modal">
            <div onClick={() => {
                    if(error && Object.keys(error).length > 0){
                        hideThisModal();
                    }else{
                        onClose();
                    }
                }} className="modal-cancel">
                <img src="/images/cancel.svg" />
            </div>
            <div>
                <div className="">
                    <div className="currentbankselected">
                        <input
                            type="checkbox"
                            defaultChecked={true}
                            name="is_guarantor"
                            onChange={(e) => setIsGuarantor(e.target.checked)}
                        />
                        <label>Require personal guarantor</label>
                    </div>
                </div>
                <Select
                    value={savedBank}
                    isMulti
                    name="colors"
                    options={activeBanks}
                    onChange={onChangeTypeofBanks}
                    className="basic-multi-select"
                    classNamePrefix="select"
                />
                <div className="currentbanklist">
                    {selectedTypeOfBanks.length ? (
                        selectedTypeOfBanks.map((item, index) => (
                            <span
                                key={item.value + "banks" + index}
                                className={
                                    activeTypeOfBank?.value === item.value
                                        ? "active"
                                        : ""
                                }
                                onClick={() => onSelecttypeOfBank(item)}
                            >
                                {item.label}
                            </span>
                        ))
                    ) : (
                        <></>
                    )}
                </div>
                <div className="assignbankbody">
                    {active_addendum_list.map((addendum, index) => {
                        const isChecked =
                            seletedPdf.includes(addendum) ||
                            savedAddendums.includes(addendum);
                        return (
                            <div
                                className="currentbankselected"
                                key={addendum + "pdf" + index}
                            >
                                <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={(e) => onChangePdf(e, addendum)}
                                />
                                <label>{addendum}</label>
                            </div>
                        );
                    })}
                </div>
            </div>
            {error && (
                <div className="error-message mt-2r all-errors">
                    Please address the following issues:
                    <br />
                    <span className="bold-error">
                        {Object.entries(error).map(([key, errorArray], index) => (
                            <span key={index}>
                                {errorArray}
                                <br />
                            </span>
                        ))}
                    </span>
                </div>
            )}
            <div className="assignbankbtnsection">
                <Button className="assignbankcancelbtn" onClick={() => {
                    if(error && Object.keys(error).length > 0){
                        hideThisModal();
                    }else{
                        onClose();
                    }
                }}>
                    Cancel
                </Button>
                <Button 
                    className="assignbanksendbtn" 
                    onClick={onSubmit}
                    disabled={error && Object.keys(error).length > 0}
                >
                    Send
                </Button>

            </div>
        </ReactModal>
    );
};

export default AssignBankModal;
